import styles from "@/components/new-api-key-popup.module.css";
import PopupShell from "@/components/popup-shell";
import * as signals from "@/signals";
import { copyText } from "@/utils";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DialogTitle } from "@headlessui/react";
import { t } from "i18next";
import { JSX } from "react";

interface NewApiKeyPopupProps {
	isShown: boolean;
	newApiKey: string;
	onClose: () => void;
}

function NewApiKeyPopup({
	isShown,
	newApiKey,
	onClose,
}: NewApiKeyPopupProps): JSX.Element {
	const handleCopyClick = (): void => {
		void copyText(newApiKey);
	};

	return (
		<PopupShell
			onClose={onClose}
			isClosing={signals.isClosingDialog.value}
			isOpen={isShown}
		>
			<DialogTitle as="h1">{t("keyCreated")}</DialogTitle>
			<div className={styles["key-container"]}>
				{newApiKey}
				<button
					className="button"
					onClick={handleCopyClick}
					type="button"
				>
					{t("copy")}
				</button>
			</div>
			<div className={styles["important-tip"]}>
				<FontAwesomeIcon icon={faTriangleExclamation} />
				{t("thisKeyIsOnlyShownOnce")}
			</div>
			<div className="button-container">
				<button
					className="default-button"
					onClick={onClose}
					type="button"
				>
					{t("ok")}
				</button>
			</div>
		</PopupShell>
	);
}

export default NewApiKeyPopup;
